import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile-info background-gray relative-position"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "profile-info__avatar-wrap flex items-center column relative-position" }
const _hoisted_4 = {
  key: 0,
  class: "profile-info__name text-weight-bold"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "profile-info__id id-block q-mb-xs" }
const _hoisted_7 = { class: "profile-info__email" }
const _hoisted_8 = {
  key: 0,
  class: "profile-info__geo flex items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_10 = { class: "label" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "profile-info__edit" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Telegram:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  class: "q-mr-xs"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.7766 2.47983L1.95657 7.03783C1.1499 7.36183 1.15457 7.81183 1.80857 8.0125L4.84323 8.95917L11.8646 4.52917C12.1966 4.32717 12.4999 4.43583 12.2506 4.65717L6.5619 9.79117H6.56057L6.5619 9.79183L6.35257 12.9198C6.65923 12.9198 6.79457 12.7792 6.96657 12.6132L8.44057 11.1798L11.5066 13.4445C12.0719 13.7558 12.4779 13.5958 12.6186 12.9212L14.6312 3.43583C14.8372 2.60983 14.3159 2.23583 13.7766 2.47983Z",
    fill: "#3366BB"
  })
], -1)
const _hoisted_17 = {
  style: {"color":"#36B"},
  class: "text-weight-bold"
}
const _hoisted_18 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Skype:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fab fa-skype q-mr-xs",
  style: {"color":"#3366BB"}
}, null, -1)
const _hoisted_22 = {
  style: {"color":"#36B"},
  class: "text-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_ProfileEditDialog = _resolveComponent("ProfileEditDialog")!
  const _component_AvatarEditDialog = _resolveComponent("AvatarEditDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_center, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_q_spinner, {
              key: 0,
              class: "col",
              color: "primary",
              size: "3em",
              thickness: 2
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.affiliate.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.affiliate.name), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_q_avatar, {
                size: "100px",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAvatarEditDialog = !_ctx.showAvatarEditDialog)),
                class: "profile-info__avatar"
              }, {
                default: _withCtx(() => [
                  (!_ctx.affiliate.image)
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        style: {"font-size":"84px"},
                        class: "photo",
                        name: "account_circle"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.affiliate.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "photo",
                        src: `${_ctx.storageUrl + '/' + _ctx.affiliate.image}`
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, " ID: " + _toDisplayString(_ctx.affiliate.id), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.affiliate.credentials.email), 1)
            ]),
            (_ctx.affiliate.geo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('country')) + ":", 1),
                  _createElementVNode("img", {
                    style: {"user-select":"none","display":"initial"},
                    class: "q-mr-sm",
                    height: "18",
                    width: "24",
                    src: 
            `http://purecatamphetamine.github.io/country-flag-icons/3x2/${_ctx.affiliate.geo.isoCode}.svg`
          
                  }, null, 8, _hoisted_11),
                  _createElementVNode("span", null, _toDisplayString(_ctx.affiliate.geo?.name), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "row no-wrap edit-block items-center cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showProfileEditDialog = !_ctx.showProfileEditDialog))
              }, [
                _createVNode(_component_q_icon, { name: _ctx.heroOutline24PencilSquare }, null, 8, ["name"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.affiliate.contacts.telegram)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, "@" + _toDisplayString(_ctx.affiliate.contacts.telegram), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.affiliate.contacts.skype)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.affiliate.contacts.skype), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showProfileEditDialog)
      ? (_openBlock(), _createBlock(_component_ProfileEditDialog, {
          key: 1,
          open: _ctx.showProfileEditDialog,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showProfileEditDialog = false)),
          onRefresh: _ctx.onRequest
        }, null, 8, ["open", "onRefresh"]))
      : _createCommentVNode("", true),
    (_ctx.showAvatarEditDialog)
      ? (_openBlock(), _createBlock(_component_AvatarEditDialog, {
          key: 2,
          open: _ctx.showAvatarEditDialog,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAvatarEditDialog = false)),
          onRefresh: _ctx.onRequest
        }, null, 8, ["open", "onRefresh"]))
      : _createCommentVNode("", true)
  ], 64))
}